import { finApi, money } from "../api";
import { buildInvoiceHtml, invoicePdf } from "./invoicePrint";

export async function docHtml(d, party, company, internal = false) {
  const s = await finApi.settings();
  const c = company || {};
  const z = s.zatca || {};
  const qr = d.zatca && d.status !== "draft" ? await finApi.zatcaQrDataUrl(d.id).catch(() => null) : null;
  return buildInvoiceHtml({ ...d, _party: party }, {
    internal, qr, logo: s.logo, theme: s.invoice_theme,
    seller: { name: z.seller_name || c.name, name_en: z.seller_name_en || c.name_en, vat: z.vat_number || c.vat_number,
      cr: z.cr_number || c.cr_number, address: z.address || c.address, city: z.city || c.city,
      street: z.street || c.street, building_number: z.building_number || c.building_number, district: z.district || c.district,
      postal_code: z.postal_code || c.postal_code, additional_number: z.additional_number || c.additional_number,
      banks: c.bank_accounts || [], stamp: c.stamp || "" },
  });
}

export const waPhone = (p) => {
  const n = String(p || "").replace(/\D/g, "");
  if (!n) return "";
  if (n.startsWith("966")) return n;
  if (n.startsWith("05")) return `966${n.slice(1)}`;
  if (n.startsWith("5") && n.length === 9) return `966${n}`;
  return n;
};

// Mobile: native share sheet with the PDF (WhatsApp appears there). Fallback: download PDF + open WhatsApp chat with a summary.
export async function shareInvoiceWhatsApp(d, party, company) {
  const html = await docHtml(d, party, company);
  const pdf = await invoicePdf(html);
  const file = new File([pdf.output("blob")], `${d.number}.pdf`, { type: "application/pdf" });
  const text = `فاتورة ${d.number} من ${company?.name || ""}\nالتاريخ: ${d.date}\nالإجمالي: ${money(d.total)} ر.س (شامل الضريبة)`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], title: d.number, text }); return "shared"; }
    catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  pdf.save(`${d.number}.pdf`);
  window.open(`https://wa.me/${waPhone(party?.phone)}?text=${encodeURIComponent(`${text}\n(مرفق ملف PDF للفاتورة)`)}`, "_blank");
  return "fallback";
}
